import { createApi } from '@reduxjs/toolkit/query/react'
import { RTKUtils } from '@sevenrooms/api'

export const baseReservationWidgetApi = createApi({
  reducerPath: 'ReservationWidgetAPI',
  baseQuery: RTKUtils.noBaseQuery,
  endpoints: () => ({}),
})
